import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DOC_TYPE } from '@app/general/shared/constants/profile';
import { IUser } from '@app/general/shared/interfaces/users';
import { DispatcherCompaniesModalComponent } from '@app/modules/shared/components/dispatcher-companies-modal/dispatcher-companies-modal.component';

@Component({
    selector: 'sbi-info-data-view-profile',
    templateUrl: './info-data.component.html',
    styleUrls: ['./info-data.component.scss'],
    standalone: false
})
export class InfoDataComponent {
  @Input() viewProfileForm: FormGroup = null;
  @Input() user: IUser = null;
  public DOC_TYPE = DOC_TYPE;
  constructor(private _matDialog: MatDialog) {}

  hasRole(role: string): boolean {
    return this.viewProfileForm.get('roles')?.value?.includes(role);
  }

  public showDispatcherList() {
    this._matDialog.open(DispatcherCompaniesModalComponent, {
      data: this.viewProfileForm.get('dispatcherManagedCompanies')?.value,
    });
  }
}
